// Gerado por `pnpm modules:sync` a partir dos module.json (ADR 0123). Não edite à mão.
import type { WebModule } from './web-module.ts';
import { webModule as factory } from './factory/module.tsx';
import factoryEn from './factory/i18n/en.json';
import factoryPtBR from './factory/i18n/pt-BR.json';

export const WEB_MODULES: readonly WebModule[] = [
  factory,
];

/** Os textos de cada módulo, debaixo da chave com o id dele (`t('<id>.…')`). */
export const MODULE_TRANSLATIONS = {
  'pt-BR': {
    factory: factoryPtBR,
  },
  en: {
    factory: factoryEn,
  },
};
